/**
 * The env the app is running in e.g. development, testflight, production, e2e
 */
export const ENV: string = import.meta.env.MODE

/**
 * Indicates whether the app is __DEV__
 */
export const IS_DEV = import.meta.env.DEV

/**
 * Indicates whether the app is PROD
 */
export const IS_PROD = import.meta.env.PROD

/**
 * Indicates whether the app is Staging
 */
export const IS_STAGING = import.meta.env.MODE === 'staging'

/**
 * Supabase API URL
 */
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL

/**
 * Supabase ANON key
 */
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY

/**
 * Sentry DSN for telemetry
 */
export const SENTRY_DSN: string | undefined = import.meta.env.VITE_SENTRY_DSN

/**
 * The log level for the app.
 */
export const PUBLIC_LOG_LEVEL = (import.meta.env.VITE_PUBLIC_LOG_LEVEL || 'info') as 'debug' | 'info' | 'warn' | 'error'

/**
 * The URL for the help center.
 */
export const HELP_CENTER_URL = import.meta.env.VITE_HELP_CENTER_URL

/**
 * CCP Account information
 */
export const CCP = {
  ACCOUNT_NUMBER: import.meta.env.VITE_CCP_ACCOUNT_HOLDER,
  ACCOUNT_HOLDER: import.meta.env.VITE_CCP_ACCOUNT_HOLDER,
  KEY: import.meta.env.VITE_CCP_KEY,
}

/**
 * Stripe publishable key
 */
export const STRIPE = {
  PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
}
